import { TextField } from "@mui/material";
import React, { useState } from "react";

// Define the possible input types

// Define the option type for select
export interface SelectOption {
  value: string | boolean;
  label: string;
}

// Define the component props
interface EditableInputCellProps {
  initialValue: string | number | Date | null;
  onEdit: (newValue: string | number | Date | null | boolean) => void;
  options?: SelectOption[]; // Required when type is 'select'
}

const EditableInputCell: React.FC<EditableInputCellProps> = ({ initialValue, onEdit }) => {
  const [currentValue, setCurrentValue] = useState(initialValue);

  // Handle input change for text, number, and date
  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentValue(event.target.value);
  };

  // Render text field for text, number, and date
  return (
    <TextField
      autoFocus
      type={"text"}
      value={currentValue}
      onChange={handleInputChange}
      onBlur={() => {
        setTimeout(() => {
          onEdit(currentValue);
        }, 0);
      }}
      size="small"
      fullWidth
      variant="standard"
    />
  );
};

export default EditableInputCell;
